<script lang="ts">
	import Button from './Button.svelte';
</script>

<div class="border-green-primary border-l-4 pl-4 lg:flex lg:justify-between">
	<div class="mb-5 lg:mb-0">
		<p class="body-bold mb-1">Invest with Confidence – Join Our Course Waitlist Today.</p>
		<p class="text-gray-dark card-regular">Secure early bird pricing now.</p>
	</div>
	<div>
		<Button
			to={{
				href: '/course-landing',
				'data-sveltekit-reload-data': 'true'
			}}
			class="inline-block"
		>
			Learn more
		</Button>
	</div>
</div>
